import { useSetAtom as t } from "jotai/index";
import { setAlertAtom as o } from "./index51.mjs";
const m = () => t(o);
export {
  m as useAlert
};
